export default __webpack_public_path__ + "static/media/helmet3.11ead621.svg";